import { useLocation, useNavigate } from 'react-router-dom';

import UnauthenticatedLayout from '@/components/layout/UnauthenticatedLayout';
import OrderConfirmation from '@/components/payment/OrderConfirmation';
import { LOGIN_ROUTE, PATIENT_ORDERS_ROUTE } from '@/routes/route-paths';

function PaymentSuccessUnauth() {
  const navigate = useNavigate();
  const location = useLocation();

  const { orderCode, usedDeliveryOption, firstName, email, onBoardKey } = location.state || {};

  // TODO analytics
  // For logged out patients we check if isReady is true

  if (!orderCode) {
    navigate(LOGIN_ROUTE, { state: { from: { pathname: PATIENT_ORDERS_ROUTE } } });
  }

  return (
    <UnauthenticatedLayout>
      <OrderConfirmation
        onBoardKey={onBoardKey}
        orderCode={orderCode}
        loggedIn={false}
        patientName={firstName}
        patientEmail={email}
        deliveryOption={usedDeliveryOption}
      />
    </UnauthenticatedLayout>
  );
}

export default PaymentSuccessUnauth;
